// The per-node config drawer: opens on a diagram-node click or a "view config" button, showing the
// inspector_data entry for that node's exact id. Extracted out of the topology Stimulus controller
// alongside tour.ts and overlays.ts — see tour.ts's header comment for why the controller keeps thin
// delegating methods (openNodeInspector/closeInspector/handleMermaidClick) rather than losing them
// entirely: Stimulus's data-action wiring and overlays.ts's portaled-listener rebinding both resolve
// action methods by name on the controller instance itself.
import DOMPurify from 'dompurify';
import { extractNodeId } from './tour';
export class Inspector {
    constructor(els, getData) {
        this.els = els;
        this.getData = getData;
    }
    openByKey(key) {
        if (!this.els.title || !this.els.content || !this.els.drawer)
            return;
        const data = (this.getData() || {})[key];
        if (data) {
            this.els.title.textContent = data.title;
            this.els.content.innerHTML = DOMPurify.sanitize(data.body);
        }
        else {
            this.els.title.textContent = `Node: ${key}`;
            this.els.content.innerHTML = `<p class="text-warning">⚠ No configuration data available for this node. This may be a display-only element in the topology.</p>`;
        }
        this.els.drawer.classList.add('active');
    }
    open(event) {
        const btn = event.currentTarget;
        const key = btn.dataset.topologyNodeParam;
        if (key)
            this.openByKey(key);
    }
    close() {
        if (this.els.drawer)
            this.els.drawer.classList.remove('active');
    }
    handleMermaidClick(event) {
        const data = this.getData();
        if (!data)
            return;
        const target = event.target;
        const node = target.closest('.node');
        if (!node)
            return;
        // Exact equality against the extracted node id, not a substring test: "VLAN_" (a real key) is a
        // substring of "HUB_VLAN_NNI11" (a different, real node id), so id.includes(k) could open the
        // wrong drawer for a node whose id happens to contain a shorter, unrelated key. extractNodeId
        // strips mermaid's render-id/index wrapping down to the id exactly as the .erb templates emit
        // it, which is also exactly what the inspector_data keys are.
        const id = extractNodeId(node.id || '');
        const matchedKey = Object.keys(data).find(k => k === id);
        if (matchedKey)
            this.openByKey(matchedKey);
    }
}
